import { render, staticRenderFns } from "./ModalEditarOrdemDeCorte.vue?vue&type=template&id=2bd5488d&lang=pug"
import script from "./ModalEditarOrdemDeCorte.vue?vue&type=script&lang=js"
export * from "./ModalEditarOrdemDeCorte.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarOrdemDeCorte.vue?vue&type=style&index=0&id=2bd5488d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports